declare namespace $ {

	type $mol_paragraph__title_demo_note_live_1 = $mol_type_enforce<
		ReturnType< $demo_note_live['status_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_demo_note_live_2 = $mol_type_enforce<
		ReturnType< $demo_note_live['last_title'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $demo_note_live extends $mol_view {
		status_title( ): string
		Status( ): $mol_paragraph
		last_title( ): string
		Last( ): $mol_paragraph
		watcher( ): any
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=live.view.tree.d.ts.map